import { RoleSubInfo, StatusSubInfo } from "../types/user";

export const ROLES = {
    USER: "user",
    CASHIER: "cashier",
    ADMIN: "admin",
    ADMINISTRATOR: "administrator",
    SUPER_ADMIN: "super admin",
    DATA_ADMIN: "data admin",
} as const;

export const tabName = {
    CLIENT: "Client",
    PACKAGE: "Package",
    ORDER: "Order",
    STAFF: "Staff",
    CHAPEL: "Chapel",
    FandB: "F&B",
    REPORTS: "Reports"
} as const;


export const CATEGORY = {
    catDefault: {
        id: 999999,
        catName: 'Select Category'
    },
    bottleDrinks: {
        id: 23,
        catName: 'Bottled Drinks'
    },
    capitalExclusives: {
        id: 2,
        catName: 'Capital Exclusives'
    },
    chocolateAndCocoa: {
        id: 22,
        catName: 'Chocolate and Cocoa'
    },
    hotCoffeeClassics: {
        id: 4,
        catName: 'Hot Coffee Classics'
    },
    icedCoffeeClassics: {
        id: 5,
        catName: 'Iced Coffee Classics'
    },
    pastries: {
        id: 3,
        catName: 'Pastries'
    },
    refresher: {
        id: 7,
        catName: 'Refreshers'
    }
}

export const PRODUCT_SIZE = {
    s8oz: {
        id: 1,
        name: '8oz'
    },
    s12oz: {
        id: 2,
        name: '12oz'
    },
    s16oz: {
        id: 3,
        name: '16oz'
    },
    sNone: {
        id: 4,
        name: 'None'
    }
}

export const STATUS_CATEGORY = {
    order: {
        name: 'Order'
    },
    user: {
        name: 'User'
    }
}

export const STATUS = {
    all: {
        id: 0,
        name: 'All' 
    },
    claimed: {
        id: 7,
        name: 'Claimed'
    },
    pending: {
        id: 3,
        name: 'Pending'
    },
    brewing: {
        id: 4,
        name: 'Brewing'
    },
    forPickUp: {
        id: 5,
        name: 'For Pick-Up'
    },
    cancelled: {
        id: 6,
        name: 'Cancelled'
    },
}

export const STATUS_ORDER = [
    "Pending",
    "Brewing",
    "For Pick-Up",
    "Claimed",
    "Cancelled",
];

export const PACKAGE_ORDER = [
    "Basic Package",
    "Brew Classic",
    "Brew Signature",
    "Other",
];

export const TABS = [
    "all",
    "Pending",
    "Brewing",
    "For Pick-Up",
    "Claimed",
    "Cancelled",
];

export const STATUS_PRIORITY: Record<string, number> = {
    "Pending": 1,
    "Brewing": 2,
    "For Pick-Up": 3,
    "Claimed": 4,
    "Cancelled": 5,
};

export const setUpSettings = [
    {
        id: 1,
        name: "Categories",
        description: "Create and organize product categories."
    },
    {
        id: 2,
        name: "Temperatures",
        description: "Manage available temperature options for products."
    },
    {
        id: 3,
        name: "Add-ons",
        description: "Add and manage optional extras that can be added to products."
    },
    {
        id: 4,
        name: "Sizes",
        description: "Manage available product sizes and serving options."
    },
];